import useGetDetailItem from "@hooks/Media/useGetMedia";
import formMapper from "@mappers/Modules/media/MediaItem.mapper";
import updateItem from "@services/Media/updateMedia";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/media/media.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyMedia";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
